/* Outdoors Nordic. Flyttad ur blocks/on-gallery-badges.liquid 2026-10-07.
   Lag inline och skickades med varje sidvisning som anvande sektionen.
   Laddas som modul: samma URL evalueras en gang oavsett antal taggar. */

  (function () {
if (customElements.get('on-gallery-enhance')) return;
class OnGalleryEnhance extends HTMLElement {
connectedCallback() {
this.gallery = this.#findGallery();
if (!this.gallery) return;
 if (this.dataset.fullBleed === 'true') this.gallery.classList.add('on-ge--fullbleed');
 this._thumbM = parseInt(this.dataset.thumb, 10) || 0;
this._thumbD = parseInt(this.dataset.thumbDesktop, 10) || 0;
if (this._thumbM > 0 || this._thumbD > 0) {
  this.gallery.classList.add('on-ge--thumb');
  if (this._thumbM > 0) this.gallery.style.setProperty('--on-ge-thumb', this._thumbM + 'px');
  if (this._thumbD > 0) this.gallery.style.setProperty('--on-ge-thumb-d', this._thumbD + 'px');
  this.applyThumbs = this.applyThumbs.bind(this);
  this.applyThumbs();
  var t = this;
  // Native re-renderar thumbnails (variant/slideshow) → sätt om inline-bredden
  setTimeout(this.applyThumbs, 300);
  this.onThumbResize = function () { clearTimeout(t._tr); t._tr = setTimeout(t.applyThumbs, 150); };
  window.addEventListener('resize', this.onThumbResize);
  document.addEventListener('variant:update', this.applyThumbs);
}
 if (this.dataset.overlay === 'true') {
  var ov = this.querySelector('[data-overlay-el]');
  if (ov) {
    this.gallery.classList.add('on-ge--has-overlay');
    this.gallery.appendChild(ov);
  }
}
 if (this.dataset.videoGif === 'true') {
  this.gallery.classList.add('on-ge--gif');
  this.applyVideoGif();
  // Native morphar galleriet vid variantbyte → återapplicera.
  this.onUpdate = this.applyVideoGif.bind(this);
  document.addEventListener('variant:update', this.onUpdate);
}
 if (this.dataset.videoThumb === 'true') {
  this.enhanceVideoThumbs = this.enhanceVideoThumbs.bind(this);
  this.enhanceVideoThumbs();
  var vt = this;
  [400, 1000, 2200].forEach(function (t) { setTimeout(vt.enhanceVideoThumbs, t); });
  document.addEventListener('variant:update', this.enhanceVideoThumbs);
  /* Videor monteras forst nar besokaren swipar fram dem, sa miniatyren kan bli
     animerbar langt efter sidladdning. Kolla om vid scroll, rAF-strypt. */
  var vtTick = false;
  document.addEventListener(
    'scroll',
    function () {
      if (vtTick) return;
      vtTick = true;
      requestAnimationFrame(function () { vtTick = false; vt.enhanceVideoThumbs(); });
    },
    { capture: true, passive: true }
  );
}
 if (this.dataset.gridPromote === 'true') this.initGridPromote();
/* Rad 67: lyftet av block ovanfor galleriet ar borttaget. Gruppen renderas
   numera av sektionen i den statiska sloten 'above-gallery', fore galleriet, sa
   ordningen kommer fran servern. Lyftet skedde efter att sidan ritats och var
   hela CLS pa mobil: 110-113 px, 0,112 av 0,167. Placeringen pa desktop ligger
   helt i CSS, sa ingen JS behovs for den. */
}
/* Dator-rutnatet: klicka en mindre bild -> den flyttas forst i listan och blir
 den stora bilden hogst upp (Horizons regel ar :first-child, sa en flytt racker).
 Ligger i capture-fasen for att hinna fore native zoom-knappen; den stora
 bilden hogst upp behaller sin zoom. */
initGridPromote() {
var g = this.gallery;
if (!g) return;
var self = this;
/* Native zoom-knapp tacker hela rutan och far klicket fore oss (den binds
   hogre upp i dokumentet), sa stopPropagation racker inte. Klassen slar av
   knappens pointer-events pa alla rutor utom den forsta: klicket landar da
   pa rutan och blir en befordran, medan den stora bilden hogst upp behaller
   sin zoom. */
g.classList.add('on-ge--promote');
this.onGridClick = function (e) {
  var ul = g.querySelector('.media-gallery__grid');
  if (!ul || getComputedStyle(ul).display === 'none') return;
  var li = e.target && e.target.closest ? e.target.closest('.product-media-container') : null;
  if (!li || li.parentElement !== ul) return;
  if (li === ul.firstElementChild) return;
  e.preventDefault();
  e.stopPropagation();
  var top = ul.getBoundingClientRect().top;
  ul.insertBefore(li, ul.firstElementChild);
  document.dispatchEvent(new CustomEvent('on:gallery:reorder'));
  /* Var listan redan uppskrollad forbi toppen hamnar den befordrade bilden
     utanfor rutan, sa vi tar med besokaren dit. */
  if (top < 0) {
    var hdr = document.querySelector('header-component, .header-wrapper');
    var off = hdr ? hdr.getBoundingClientRect().height : 0;
    window.scrollTo({ top: window.scrollY + ul.getBoundingClientRect().top - off - 12, behavior: 'smooth' });
  }
};
g.addEventListener('click', this.onGridClick, true);
}
disconnectedCallback() {
if (this.onGridClick && this.gallery) this.gallery.removeEventListener('click', this.onGridClick, true);
if (this.onUpdate) document.removeEventListener('variant:update', this.onUpdate);
if (this.dataset.videoThumb === 'true' && this.enhanceVideoThumbs) document.removeEventListener('variant:update', this.enhanceVideoThumbs);
if (this.onResize) window.removeEventListener('resize', this.onResize);
if (this.onThumbResize) window.removeEventListener('resize', this.onThumbResize);
if (this.applyThumbs) document.removeEventListener('variant:update', this.applyThumbs);
}
/* Sätt miniatyrbredd inline (bulletproof – kringgår Horizons clamp + mobil-reset) */
applyThumbs() {
if (!this.gallery) return;
var mobile = window.innerWidth <= 749;
var size = mobile ? this._thumbM : this._thumbD;
var thumbs = this.gallery.querySelectorAll('.slideshow-controls__thumbnail, .slideshow-controls__thumbnails .slideshow-control');
for (var i = 0; i < thumbs.length; i++) {
  var el = thumbs[i];
  if (size && size > 0) {
    el.style.setProperty('width', size + 'px', 'important');
    el.style.setProperty('max-width', size + 'px', 'important');
    el.style.setProperty('flex', '0 0 ' + size + 'px', 'important');
  } else {
    el.style.removeProperty('width'); el.style.removeProperty('max-width'); el.style.removeProperty('flex');
  }
}
}
#findGallery() {
// Galleriet ligger i samma sektion; fall tillbaka på sidans första.
var section = this.closest('.shopify-section, [id^="shopify-section"]') || document;
return section.querySelector('media-gallery') || document.querySelector('media-gallery');
}
applyVideoGif() {
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
this.gallery.querySelectorAll('video').forEach(function (v) {
  v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
  v.setAttribute('muted', ''); v.setAttribute('loop', ''); v.setAttribute('playsinline', '');
  v.removeAttribute('controls');
  v.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
  v.setAttribute('disablepictureinpicture', '');
  if (reduce) { try { v.pause(); } catch (e) {} return; }
  v.autoplay = true; v.setAttribute('autoplay', '');
  var p = v.play && v.play();
  if (p && p.catch) p.catch(function () {});
});
}
/* Video-miniatyrer: lagg en liten autoplay/muted/loop-video ovanpa postern sa att
 miniatyren ror sig. Respekterar reduce-motion.
  Matchar pa POSTERBILD, inte pa ordning (2026-08-19). Positionsmatchning (thumbs[i]
 mot slides[i]) glider sa fort de tva listorna inte innehaller exakt samma poster i
 exakt samma ordning, och da hamnade videon pa en ruta bredvid SAMTIDIGT som den
 spelades i sin egen. Miniatyren och den stora videon delar samma forhandsbild, sa
 den kopplingen kan per definition inte glida isar.
  Miniatyren far dessutom bara animera en fil som redan ar nedladdad for den stora
 bilden (currentSrc + readyState), annars tvingas hela galleriet ned i 80x80-format. */
enhanceVideoThumbs() {
if (!this.gallery) return;
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (reduce) return;
var g = this.gallery;
 /* Filnamnet utan query och utan Shopifys ev. _400x-suffix. Postern renderas i en
   bredd och miniatyren i en annan, men grundfilen ar densamma. */
function posterKey(url) {
  if (!url) return '';
  var s = String(url).split('?')[0];
  s = s.substring(s.lastIndexOf('/') + 1);
  return s.replace(/_\d+x\d*(\.[a-z0-9]+)$/i, '$1').toLowerCase();
}
 /* Karta: posterbild -> nedladdad videokalla, byggd fran de bilder som ar monterade. */
var byPoster = {};
var slides = g.querySelectorAll('slideshow-slide');
if (!slides.length) slides = g.querySelectorAll('.product-media-container');
for (var s = 0; s < slides.length; s++) {
  var big = slides[s].querySelector('video');
  if (!big || !big.currentSrc || big.readyState < 2) continue;
  var bk = posterKey(big.getAttribute('poster'));
  if (bk && !byPoster[bk]) byPoster[bk] = big.currentSrc;
}
if (!Object.keys(byPoster).length) return;
 /* En videofil far animera EN miniatyr. */
var used = {};
var fanns = g.querySelectorAll('video.on-ge__vthumb');
for (var u = 0; u < fanns.length; u++) used[fanns[u].src] = 1;
 var thumbs = g.querySelectorAll('.slideshow-controls__thumbnail');
for (var i = 0; i < thumbs.length; i++) {
  var thumb = thumbs[i];
  if (thumb.dataset.onVid) continue;
  var img = thumb.querySelector('img');
  if (!img) continue;
  var src = byPoster[posterKey(img.getAttribute('src') || img.src)];
  if (!src || used[src]) continue;
  used[src] = 1;
  thumb.dataset.onVid = '1';
  var mini = document.createElement('video');
  mini.className = 'on-ge__vthumb';
  mini.muted = true; mini.defaultMuted = true; mini.loop = true; mini.playsInline = true; mini.autoplay = true;
  mini.setAttribute('muted', ''); mini.setAttribute('loop', ''); mini.setAttribute('playsinline', ''); mini.setAttribute('autoplay', '');
  mini.setAttribute('preload', 'metadata'); mini.setAttribute('disablepictureinpicture', '');
  mini.src = src;
  var host = thumb.querySelector('.slideshow-controls__thumbnail-image') || thumb;
  host.classList.add('on-ge__vthumb-host');
  host.appendChild(mini);
  var pp = mini.play && mini.play();
  if (pp && pp.catch) pp.catch(function () {});
}
}
}
customElements.define('on-gallery-enhance', OnGalleryEnhance);
  })();

